const KEY = 'scrivio.adminAccessDenied'

/**
 * Survives Keycloak's sign-out, which leaves the page and comes back to the login page through a
 * full load. In `sessionStorage` so it stays with the tab that was refused.
 */
export function rememberAdminAccessDenied(): void {
  sessionStorage.setItem(KEY, 'true')
}

/** Whether a refusal is waiting to be shown; the login route stays put while one is. */
export function isAdminAccessDenied(): boolean {
  return sessionStorage.getItem(KEY) !== null
}

/** Reads the refusal and forgets it, so it is shown once. */
export function takeAdminAccessDenied(): boolean {
  const denied = isAdminAccessDenied()
  sessionStorage.removeItem(KEY)
  return denied
}
